interface MonitorIconProps {
  width?: number;
  height?: number;
  strokeWidth?: number;
}

const MonitorIcon = ({ width = 30, height = 30, strokeWidth = 10 }: MonitorIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth={strokeWidth}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.64 5.32009H20.59C20.8412 5.31877 21.0902 5.36727 21.3225 5.46278C21.5548 5.5583 21.7659 5.69894 21.9436 5.87657C22.1212 6.05419 22.2618 6.26527 22.3573 6.4976C22.4529 6.72993 22.5014 6.9789 22.5 7.23009V16.7701C22.5014 17.0213 22.4529 17.2703 22.3573 17.5026C22.2618 17.7349 22.1212 17.946 21.9436 18.1236C21.7659 18.3012 21.5548 18.4419 21.3225 18.5374C21.0902 18.6329 20.8412 18.6814 20.59 18.6801H3.41003C3.15883 18.6814 2.90987 18.6329 2.67754 18.5374C2.44521 18.4419 2.23412 18.3012 2.0565 18.1236C1.87887 17.946 1.73823 17.7349 1.64272 17.5026C1.5472 17.2703 1.4987 17.0213 1.50003 16.7701V7.23009C1.4987 6.9789 1.5472 6.72993 1.64272 6.4976C1.73823 6.26527 1.87887 6.05419 2.0565 5.87657C2.23412 5.69894 2.44521 5.5583 2.67754 5.46278C2.90987 5.36727 3.15883 5.31877 3.41003 5.32009H4.41003"
        stroke="#1B365D"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M12 22.4999V18.6799" stroke="#1B365D" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M16.7705 22.5H7.23047" stroke="#1B365D" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M12 3.40991V8.17991" stroke="#1B365D" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M12 9.13989V11.0499" stroke="#1B365D" strokeWidth="1.5" strokeMiterlimit="10" />
      <path
        d="M11.9995 12.96C15.1641 12.96 17.7295 10.3946 17.7295 7.23C17.7295 4.06541 15.1641 1.5 11.9995 1.5C8.83494 1.5 6.26953 4.06541 6.26953 7.23C6.26953 10.3946 8.83494 12.96 11.9995 12.96Z"
        stroke="#1B365D"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default MonitorIcon;
